// extracted by mini-css-extract-plugin
module.exports = {"tabsHeaderContainer":"_9DWZC","tabsContainer":"_1jLJr","tabs":"_1vpfe","icon":"_1NeMH","indicator":"_3M7UY","description":"_2qtYo"};